import { createFileRoute } from '@tanstack/react-router'
import { RegisterPage } from '../components/auth-pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/inscription')({
  head: () => noIndexRouteHead('register', 'fr'),
  component: RegisterPage,
})
